import { OverrideChoice } from './types';

export const OVERRIDE_CHOICES: OverrideChoice[] = [
  { id: 1, name: 'NULL' },
  { id: 2, name: 'SHOW' },
  { id: 3, name: 'HIDE' },
];
